import { Button, Checkbox, List } from 'antd'
import React, { useRef } from 'react'
import { useProjectConfig } from '../../hooks/useProjectConfig'
import { LanguageType } from '../../Types'

/**
 * Created by @author Søren Tramm
 */
type AddLanguageProps = {
  savedLanguageList: LanguageType[]
  updatedLanguageList: LanguageType[]
  onUpdateLanguages: (languageSelection: any[]) => void
  onClose?: () => void
}

export const ProjectAddLanguage = ({
  savedLanguageList,
  updatedLanguageList,
  onUpdateLanguages,
  onClose,
}: AddLanguageProps) => {
  const { data: projectConfig } = useProjectConfig()
  const { languages: systemLanguages } = projectConfig

  console.log('projectLanguages > ', updatedLanguageList)

  const savedLanguageSet = savedLanguageList.reduce((acc, lang) => {
    return acc.add(lang.isoCode)
  }, new Set<string>())

  const updatedLanguageMap = updatedLanguageList.reduce((acc, lang) => {
    return acc.set(lang.isoCode, lang)
  }, new Map<string, LanguageType>())

  const systemLanguageMap = systemLanguages.reduce((acc, lang) => {
    return acc.set(lang.isoCode, lang)
  }, new Map())

  const selectedIsoCodes = useRef<Set<string>>(new Set())

  const onChange = (isoCode: string, checked: boolean) => {
    if (checked) {
      selectedIsoCodes.current.add(isoCode)
    } else {
      selectedIsoCodes.current.delete(isoCode)
    }
  }

  const saveSelected = () => {
    // TODO Save

    const isoCodes = Array.from(selectedIsoCodes.current)
    const selected = isoCodes.map((isoCode) => systemLanguageMap.get(isoCode))

    onUpdateLanguages(updatedLanguageList.concat(selected))

    if (onClose) {
      onClose()
    }
  }

  const cancelSelected = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <div className="container-fluid p-0">
      <div className="row rounded-2" style={{ background: '#f3f3f3' }}>
        <div className="col-12 py-4 mb-2">
          <p>Please select languages to be added to the project</p>
        </div>
      </div>
      <div className="row">
        <List
          className="mt-2"
          size="small"
          bordered
          dataSource={systemLanguages}
          renderItem={(language) => (
            <List.Item>
              <div className="col-12 d-flex align-items-center">
                <div className="col-6">
                  <p>{language.name}</p>
                </div>
                <div className="col-1">
                  <Checkbox
                    value={{ name: language.name, isoCode: language.isoCode }}
                    defaultChecked={updatedLanguageMap.has(language.isoCode)}
                    disabled={savedLanguageSet.has(language.isoCode)}
                    onChange={(e) => onChange(language.isoCode, e.target.checked)}
                  ></Checkbox>
                </div>
                <div className="col-5 d-flex justify-content-end">
                  <p className="small">{updatedLanguageMap.get(language.isoCode)?.active ? 'Active' : ''}</p>
                </div>

                {/*<div>{updatedLanguageMap.get(language.isoCode)?.active ? 'Active' : ''}</div>*/}
              </div>
            </List.Item>
          )}
        />
      </div>
      <div className="row">
        <div className="col-12 d-flex px-0  mt-3 justify-content-end">
          <Button type="text" className="me-2" onClick={cancelSelected}>
            Cancel
          </Button>
          <Button type="primary" disabled={systemLanguages.length === 0} onClick={saveSelected}>
            Save selection
          </Button>
        </div>
      </div>
    </div>
  )
}
